import getTheme from "./getTheme";
export default function color(index, theme) {
    return getTheme(theme).space[index] + "px";
}
//# sourceMappingURL=space.js.map